import React from "react";
import { useTranslation } from "react-i18next";

import LanguageTable from "../../../Common/LanguageTable";
import { SubmitButtonConfig } from "../constants";
import { ColorPickerField } from "./ColorPickerField";

interface Props {
    basePath: string[];
    submitBtn: any;
    defaultSubmitButton: SubmitButtonConfig;
    mainColor: string;
    updatePath: (path: string[], value: any) => void;
}

export function SubmitButtonSection({
    basePath,
    submitBtn,
    defaultSubmitButton,
    mainColor,
    updatePath,
}: Props) {
    const { t } = useTranslation();
    const btnColor = submitBtn?.Color || defaultSubmitButton.Color;

    return (
        <div
            data-testid="submit-button-section"
            style={{
                marginBottom: 24,
                padding: 16,
                border: "1px solid #e0e0e0",
                borderRadius: 8,
            }}
        >
            <h6
                style={{
                    fontWeight: 700,
                    fontSize: 15,
                    marginBottom: 16,
                    color: mainColor,
                    textTransform: "uppercase",
                }}
            >
                {t("Submit button")}
            </h6>

            <LanguageTable
                path={[...basePath, "SubmitButton"]}
                fields={[
                    {
                        key: "Label",
                        label: "Button label",
                        placeholder: "Enter button text",
                        isVisible: submitBtn?.LabelVisible ?? true,
                        onVisibilityToggle: () =>
                            updatePath(
                                [...basePath, "SubmitButton", "LabelVisible"],
                                !(submitBtn?.LabelVisible ?? true)
                            ),
                    },
                ]}
                defaultTexts={defaultSubmitButton}
                sectionTitle={t("Button text")}
            />

            <div className="mt-3">
                <ColorPickerField
                    label={t("Button color")}
                    color={btnColor}
                    onChange={(hex) =>
                        updatePath(
                            [...basePath, "SubmitButton", "Color"],
                            hex
                        )
                    }
                />
            </div>
        </div>
    );
}
